import { Component, Input } from '@angular/core';

@Component({
  selector: 'kt-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
})
export class TooltipComponent {
  @Input() text = '';
  @Input() position: 'top' | 'bottom' | 'left' | 'right' = 'top';
  @Input() textAlign: 'left' | 'right' | 'center' = 'center';
  @Input() maxWidth = '150px';
}
